<ng-container *transloco="let t; prefix: 'trip-finances.panels.gl-donation'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="form" (ngSubmit)="save()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-sm font-medium" for="donation-date">{{ t('date') }}</label>
                <input id="donation-date" type="date" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="date" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="donation-amount">{{ t('amount') }}</label>
                <input id="donation-amount" type="number" min="0.01" step="0.01" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="amount" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="donation-name">{{ t('name') }}</label>
                <input id="donation-name" type="text" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="name" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="donation-email">{{ t('email') }}</label>
                <input id="donation-email" type="email" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="email" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="donation-type">{{ t('type') }}</label>
                <select id="donation-type" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="type">
                  @for (opt of donationTypes; track opt.value) {
                    <option [ngValue]="opt.value">{{ t(opt.labelKey) }}</option>
                  }
                </select>
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="donation-check">{{ t('check-number') }}</label>
                <input id="donation-check" type="text" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="checknum" />
              </div>
            </div>

            <div>
              <label class="mb-1 block text-sm font-medium" for="donation-note">{{ t('note') }}</label>
              <textarea id="donation-note" rows="4" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="note"></textarea>
            </div>

            <app-participant-assignment-editor
              [totalAmount]="amount()"
              [(assignEnabled)]="assignEnabled"
              [(links)]="links"
              [roster]="roster()"
            />
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border px-4 py-2 text-sm font-semibold" (click)="cancel()" [disabled]="submitting()">
          {{ t('cancel') }}
        </button>
        <button type="submit" class="btn btn-primary btn-no-grow disabled:opacity-50" [disabled]="submitting() || !assignmentValid()">
          {{ t('save') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
